import React, { Component, useState, useEffect } from 'react'
import DeliveryOrder from '../presentational-components/DeliveryOrder'
import { Button, FormControl, Form, Modal, Table } from 'react-bootstrap'
import { dummy_resetAddDelivery } from '../../store/actions/index'
import { FetchCreateTransaction, FetchCreateTransactionDraft, FetchUpdateTransactionDraft } from '../../fetcher'

import '../../index.css'
import { ModalComponent } from '../presentational-components/ModalComponent'
import AlertMessage from '../presentational-components/AlertMessage'

const DeliveryOrderList = ({ dispatch, removeOrderEntry, deliveryOrders, remark, isFaexDelivery, boutique, resetOrderEntries, handleCloseMask, reloadParent, isDraftUpdate = false, draftSysId = null, transactionNumber = "", transactionDate = "", isBackDelivery = false, designerStorageSysId = ""}) => {

    useEffect(() => {
        console.log("DeliveryOrderListXXX", deliveryOrders)

        console.log(deliveryOrders)
        console.log("DeliveryOrderList removeOrderEntry XXX", isDraftUpdate)

        console.log(isDraftUpdate)
    }, [])

    const [show, setShow] = useState(false)

    const handleClose = () => setShow(false)
    const handleShow = () => setShow(true)

    const OpenModal = () => {
        return (
            handleShow()
        )
    }

    const [showAlertMessage, setShowAlert] = useState(false)
    const openAlert = () => {
        setShowAlert(true)
    }
    const closeAlert = () => {
        setShowAlert(false)
    }

    const [hasInvalidArticles, setHasInvalidArticles] = useState(false)

    const [isCreating, setIsCreating] = useState(false)

    const submitDelivery = () => {
        const transactionToCreate = {
            TransactionType: "Delivery",
            SerializedArticleData: JSON.stringify(deliveryOrders),
            IsFAEXDelivery: isFaexDelivery,
            BoutiqueSysId: isBackDelivery ? designerStorageSysId : boutique.StorageSysId,
            Remark: remark,
            CreateTransactionFromDraft: isDraftUpdate,
            TransactionNumber: transactionNumber,
            TransactionDate: transactionDate
        };
        isDraftUpdate ? /*-- do create Transaction from draft here --*/ FetchUpdateTransactionDraft(transactionToCreate, draftSysId, handleCloseMask, openAlert, reloadParent, resetOrderEntries, setIsCreating)
            : FetchCreateTransaction(transactionToCreate, handleCloseMask, openAlert, reloadParent, resetOrderEntries, setIsCreating)
        
        //resetOrderEntries()

        //console.log("DeliveryOrder close")
        //console.log(handleCloseMask)
        //if (handleCloseMask != null) {
        //    handleCloseMask()
        //}
        handleClose()
    }

    const saveDelivery = () => {
        const transactionToCreate = {
            TransactionType: "Delivery",
            SerializedArticleData: JSON.stringify(deliveryOrders),
            IsFAEXDelivery: isFaexDelivery,
            BoutiqueSysId: isBackDelivery ? designerStorageSysId : boutique.StorageSysId,
            Remark: remark,
            TransactionNumber: transactionNumber,
            TransactionDate: transactionDate
        };
        isDraftUpdate ? FetchUpdateTransactionDraft(transactionToCreate, draftSysId, handleCloseMask, openAlert, reloadParent, resetOrderEntries, setIsCreating)
            : FetchCreateTransactionDraft(transactionToCreate, handleCloseMask, openAlert, reloadParent, resetOrderEntries, setIsCreating)

        //resetOrderEntries()

        //console.log("DeliveryOrder close")
        //console.log(handleCloseMask)
        //if (handleCloseMask != null) {
        //    handleCloseMask()
        //}
        handleClose()
    }

    return (
        <div className="listtable table-width">
            <Form onSubmit={e => {
                e.preventDefault()
                OpenModal()
            }}>
                <Table striped hover aria-labelledby="tabelLabel" size="sm">
                    {deliveryOrders.map(entry =>
                        <DeliveryOrder removeOrderEntry={removeOrderEntry} {...entry} isDeliveryOrder={true} setHasInvalidArticles={setHasInvalidArticles} />
                    )}
                </Table>

                {deliveryOrders != null && deliveryOrders.length != 0 && <Button variant="secondary" type="submit" disabled={isCreating || transactionDate == ""}>Lieferung bestätigen</Button>}
            </Form>

            <ModalComponent handleShow={show} handleClose={handleClose} handleSubmit={submitDelivery} isDraftModal={true} handleSave={saveDelivery}
                modalTitle="Lieferung bestätigen"
                modalBody="Möchten Sie den Lieferschein zwischenspeichern oder abschicken? Nach dem Abschicken kann er nicht mehr bearbeitet werden!" />

            <AlertMessage showAlertMessage={showAlertMessage} closeAlert={closeAlert} />
        </div>
    )
}

export default DeliveryOrderList